const types = {
    accessGranted : 'ACCESS_GRANTED',
    logout : 'LOGOUT'
    
}

export default types;